import React from "react";
import tanvoxabout from '../assets/tanvoxabout.jpg';

const About = () => {
  const team = [
{ name: "Sare Chinna Venkata Subbaiah", role: "CEO", description: "Visionary leader with 5+ years in tech innovation" },
    { name: "Veera Bangaru", role: "CFO", description: "Financial expert ensuring sustainable growth" },
    { name: "Dattimola Naveen", role: "CTO", description: "Technical architect of cutting-edge solutions" },
    { name: "Siddartha Nemail ", role: "CMO", description: "Marketing strategist building brand excellence" },
    { name: "Kalvacherla Akhil", role: "COO", description: "Operations expert driving efficiency and growth" }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(218, 212, 212, 0.7), rgba(19, 1, 66, 0.8)), url(${tanvoxabout})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 fade-in animate-fade-in-up">
            About <span className="text-navy-blue">Us</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto fade-in animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            Learn more about our journey, values, and the team behind Tanvox Technologies
          </p>
        </div>
      </section>

      {/* Company Description & Stats */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Our <span className="text-navy-blue">Story</span>
            </h2>

            <p className="text-xl text-slate-800 mb-8 leading-relaxed">
              Founded in 2025, Tanvox Technologies has been at the forefront of
              digital innovation. We started with a simple mission: to help
              businesses leverage technology to achieve their full potential.
            </p>

            <p className="text-xl text-slate-800 mb-12 leading-relaxed">
              Our team of expert developers, designers, and consultants work
              together to deliver solutions that exceed expectations and build
              long-term partnerships.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <div className="text-3xl font-bold text-dark-red mb-2">500+</div>
                <div className="text-slate-700">Projects Completed</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-navy-blue mb-2">50+</div>
                <div className="text-slate-700">Team Members</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-dark-red mb-2">200+</div>
                <div className="text-slate-700">Happy Clients</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-navy-blue mb-2">10+</div>
                <div className="text-slate-700">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Our <span className="text-navy-blue">Leadership Team</span>
            </h2>
            <p className="text-xl text-slate-700 max-w-3xl mx-auto">
              Meet the experienced professionals driving our success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {team.map((member, index) => (
              <div
                key={index}
                className="text-center fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-32 h-32 bg-gradient-to-br from-dark-red to-navy-blue rounded-full flex items-center justify-center text-white font-bold text-3xl mx-auto mb-4">
                  {member.name.split(" ").map(n => n[0]).join("")}
                </div>
                <h3 className="text-xl font-bold text-dark-red mb-1">
                  {member.name}
                </h3>
                <div className="text-navy-blue font-semibold mb-3">
                  {member.role}
                </div>
                <p className="text-slate-700 text-sm leading-relaxed">
                  {member.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
